import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="checklist"
export default class extends Controller {
  static targets = ['header', 'box', 'actions']

  static values = {
    totalCount: Number,
    checkedCount: Number
  }

  connect () {
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('keyup', this.keyUp)
  }

  disconnect () {
    window.removeEventListener('keydown', this.keyDown)
    window.removeEventListener('keyup', this.keyUp)
  }

  keyDown = event => this.enableShiftSelect(event)
  keyUp = event => this.disableShiftSelect(event)

  checkHeader () {
    const isCheckedAll = this.totalCountValue === this.checkedCountValue

    this.boxTargets.forEach(checkbox => {
      checkbox.checked = !isCheckedAll
    })

    this.#update()
  }

  checkBox (event) {
    if (this.isShifting && this.lastCheckedCheckbox) {
      this.#shiftSelect(this.lastCheckedCheckbox, event.target)
    }

    this.lastCheckedCheckbox = event.target

    this.#update()
  }

  disableShiftSelect (event) {
    if (event.key === 'Shift') {
      this.isShifting = false
    }
  }

  enableShiftSelect (event) {
    if (event.key === 'Shift') {
      this.isShifting = true
    }
  }

  #shiftSelect (from, to) {
    const start = this.boxTargets.indexOf(from)
    const end = this.boxTargets.indexOf(to)

    this.boxTargets.slice(Math.min(start, end), Math.max(start, end) + 1).forEach(checkbox => {
      checkbox.checked = true
    })
  }

  #update () {
    this.totalCountValue = this.boxTargets.length
    this.checkedCountValue = this.boxTargets.filter(box => box.checked).length

    if (this.totalCountValue === this.checkedCountValue) {
      this.headerTarget.checked = true
      this.headerTarget.indeterminate = false
    } else if (this.checkedCountValue > 0) {
      this.headerTarget.indeterminate = true
    } else {
      this.headerTarget.checked = false
      this.headerTarget.indeterminate = false
    }

    if (this.checkedCountValue > 0) {
      this.actionsTarget.classList.remove('hidden')
    } else {
      this.actionsTarget.classList.add('hidden')
    }
  }
}
